import React from 'react';

//Bootstrap
import { Row } from 'react-bootstrap';

import InfoCustomCard from '../../../components/InfoCustomCard/InfoCustomCard';

const TimelineItem = (props) => {
    return (
        <Row className={props.left ? "px-5 py-4 justify-content-start text-align-center text-left" :
            (props.right ? "px-5 py-4 justify-content-end text-align-center text-right" : "px-5 py-4 justify-content-start text-align-center text-left")} >
            <InfoCustomCard id={props.id} title={props.title} classes="my-3 my-md-0" flex={{ md: "8" }} timeline>
                <p className="custom-description mb-0">{props.years}</p>
                <p className="custom-name-progress">{props.position}</p>
                <p className="custom-description">{props.description}</p>
            </InfoCustomCard>
        </Row >
    );
};

export default TimelineItem;